// extracted by mini-css-extract-plugin
export var copy = "styles-module--copy--aVEwS";
export var services = "styles-module--services--lOE71";